import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const ModalComponent = ({ open, handleClose, title, children, type }) => {
    return (
        <>
            <Dialog
                // fullWidth
                maxWidth="xl"
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    {children}
                </DialogContent>
                {
                    type === "Category" ? null : <DialogActions>
                        <button className='bg-red-500 cursor-pointer text-white rounded-md p-3 border-none outline-none' onClick={handleClose}>
                            Close
                        </button>
                    </DialogActions>
                }

            </Dialog>
        </>
    )
}

export default ModalComponent